module.exports = __webpack_public_path__ + "img/BAU Seniors_18.beb08583.jpg";